import { clsx } from "clsx"
import { extendTailwindMerge, validators } from "tailwind-merge"

export const hideScrollbar = `
  -ms-overflow-style: none;
  scrollbar-width: none;
  ::-webkit-scrollbar {
    width: 0px;
    background: transparent;
    display: none;
  };
`

const customTwMerge = extendTailwindMerge({
  override: {
    classGroups: {
      "font-size": [
        "display-lg",
        "display-md",
        "h1",
        "h2",
        "h3",
        "body",
        "body-lg",
        "body-sm",
        {
          text: [
            "base",
            validators.isTshirtSize,
            validators.isArbitraryLength,
            validators.isInteger,
          ],
        },
      ],
      tracking: [
        {
          tracking: [
            "tightest",
            "tighter",
            "tight",
            "normal",
            "half",
            "wide",
            "wider",
            "widest",
            validators.isArbitraryValue,
          ],
        },
        { "tracking-em": [validators.isInteger] },
        { "tracking-px": [validators.isInteger] },
      ],
    },
  },
})

export function cn(...inputs) {
  const classnames = clsx(inputs)
  return classnames ? customTwMerge(classnames) : undefined
}
